import { createContext } from "react";

const CatTipoRecetaContext = createContext();

export default CatTipoRecetaContext;
